import CommonUtils from '@/resources/utils/common-utils';
import API from '@/config/api';


const poster = {

    state: {

    },

    mutations: {
        /**
         * 获取海报分类列表
         * @param state
         * @param data
         */
        getPosterCategoryLists(state, data) {
            data.url = API.poster.getPosterCategoryLists;
            CommonUtils.GetRequest(data);
        },

        getPosterCategoryListsNoPagination(state, data) {
            data.url = API.poster.getPosterCategoryListsNoPagination;
            CommonUtils.GetRequest(data);
        },

        /**
         * 启用/停用 海报分类
         * @param state
         * @param data
         */
        togglePosterCategoryStatus(state, data) {
            data.url = API.poster.togglePosterCategoryStatus;
            CommonUtils.PostRequest(data);
        },

        /**
         * 删除海报分类
         * @param state
         * @param data
         */
        deletePosterCategory(state, data) {
            data.url = API.poster.deletePosterCategory;
            CommonUtils.GetRequest(data);
        },

        /**
         * 添加海报分类
         * @param state
         * @param data
         */
        addPosterCategory(state, data) {
            data.url = API.poster.addPosterCategory;
            CommonUtils.PostRequest(data);
        },

        /**
         * 获取海报分类详情
         * @param state
         * @param data
         */
        getPosterCategoryInfo(state, data) {
            data.url = API.poster.getPosterCategoryInfo;
            CommonUtils.GetRequest(data);
        },

        /**
         * 更新海报分类详情
         * @param state
         * @param data
         */
        editPosterCategory(state, data) {
            data.url = API.poster.editPosterCategory;
            CommonUtils.PostRequest(data);
        },

        getPoster(state, data) {
            data.url = API.poster.getPoster;
            CommonUtils.GetRequest(data);
        },

        deletePoster(state, data) {
            data.url = API.poster.deletePoster;
            CommonUtils.GetRequest(data);
        },

        showPoster(state, data) {
            data.url = API.poster.showPoster;
            CommonUtils.PostRequest(data);
        },

        recommendPoster(state, data) {
            data.url = API.poster.recommendPoster;
            CommonUtils.PostRequest(data);
        },

        stickPoster(state, data) {
            data.url = API.poster.stickPoster;
            CommonUtils.PostRequest(data);
        },

        addPoster(state, data) {
            data.url = API.poster.addPoster;
            CommonUtils.PostRequest(data);
        },

        getPosterInfo(state, data) {
            data.url = API.poster.getPosterInfo;
            CommonUtils.GetRequest(data);
        },

        editPoster(state, data) {
            data.url = API.poster.editPoster;
            CommonUtils.PostRequest(data);
        }
    }

};

export default poster;


// WEBPACK FOOTER //
// ./src/store/modules/poster.js